import React, { useMemo } from 'react';

import { WizardTabProps } from './types';

const Component: React.FC<WizardTabProps> = React.memo(
    React.forwardRef(({ title, shape, color = '#2196f3', isActive, index, onClick, isChecked: isCheckedProp }, ref) => {
        const stepClasses = isActive ? 'active' : '';
        const [isChecked, setIsChecked] = React.useState(!!isCheckedProp);
        React.useEffect(() => {
            if (isActive) {
                setIsChecked(true);
            }
        }, [isActive]);

        const colorStyle = useMemo(() => {
            if (isActive && isChecked) {
                return { color: 'white' };
            }
            if (isChecked) {
                return { color };
            }
        }, [isActive, isChecked, color]);
        React.useImperativeHandle(ref, () => ({
            setChecked: (value: boolean) => {
                setIsChecked(value);
            },
            isChecked,
        }));

        return (
            <li key={index} className={stepClasses} style={{ maxWidth: 120, overflow: 'hidden' }}>
                <button
                    type="button"
                    className={`btn btn-link p-0 border-0 ${isActive ? 'active' : ''}`}
                    style={{ cursor: 'pointer' }}
                    onClick={onClick}
                >
                    <div
                        className={`wizard-icon-circle ${isChecked ? 'checked' : ''} ${isActive ? 'active' : ''} ${shape === 'square' ? 'square_shape' : ''}`}
                        role="tab"
                        tabIndex={isActive ? 0 : undefined}
                        id={`step-${index}`}
                        aria-controls={`step-${index}`}
                        aria-disabled={isActive}
                        aria-selected={isActive}
                        style={{
                            borderColor: isChecked ? color : '',
                        }}
                    >
                        <div
                            className={`wizard-icon-container ${shape === 'square' ? 'square_shape' : ''}`}
                            style={{
                                backgroundColor: isActive ? color : '',
                                ...colorStyle,
                            }}
                        >
                            {title}
                        </div>
                    </div>
                </button>
            </li>
        );
    }),
);
Component.displayName = 'WizardTab';
export const WizardTab: React.FC<WizardTabProps> = Object.assign(Component, {});
